import React, { useState, useEffect } from 'react'
import kebabCase from 'lodash.kebabcase'

import { PricingBox } from '@/components/molecules/PricingBox/PricingBox'
import { currencyToSymbolMap, getCurrency } from '@/utils/getCurrencySymbol'
import { DynamicHeading } from '@/components/molecules/DynamicHeading/DynamicHeading'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { PricingTypes } from './types'

export function PricingSection({ heading, sub_title, pricing_box, bg_image }: PricingTypes) {
  const [currency, setCurrency] = useState('')

  useEffect(() => {
    fetch('https://ipinfo.io/?token=1c668152975d04')
      .then((r) => r.json())
      .then(({ country }) => {
        setCurrency(getCurrency(country))
      })
      .catch(() => {
        setCurrency('EUR')
      })
  }, [])

  return (
    <div
      className="bg-no-repeat bg-center-bottom bg-clip-padding"
      style={bg_image?.image ? { backgroundImage: `url(${bg_image?.image})` } : undefined}
      id={heading ? kebabCase(heading[0].text) : ''}
    >
      <section className="flex items-center flex-col max-w-screen-desktop mx-auto p-24 netbook:py-64 netbook:px-90">
        {heading && (
          <DynamicHeading
            {...heading[0]}
            className="text-headingL-mobile font-bold text-text-dark-900 mb-24 netbook:text-headingM"
          />
        )}
        <div className="text-bodyL text-text-dark-900 max-w-2xl text-center">
          {typeof sub_title === 'string' ? sub_title : <RichTextField data={sub_title} />}
        </div>
        <div className="flex flex-col tablet:flex-row justify-center space-y-24 tablet:space-y-0 tablet:space-x-24 mt-40">
          {pricing_box.map(
            ({ price_info, title: box_title, box_list, featured, _uid, buttons, price_eur, price_gbp, price_usd }) => {
              const price = currency === 'EUR' ? price_eur : currency === 'GBP' ? price_gbp : price_usd
              const currencySymbol = currencyToSymbolMap[currency]
              return (
                <PricingBox
                  key={_uid}
                  price={price}
                  price_info={price_info}
                  title={box_title}
                  box_list={box_list}
                  featured={featured}
                  currencySymbol={currencySymbol}
                  buttons={buttons}
                />
              )
            }
          )}
        </div>
      </section>
    </div>
  )
}
